<template>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" :width="width" :height="height" version="1.1"
         style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
         viewBox="0 0 61 90"
         xmlns:xlink="http://www.w3.org/1999/xlink">
     <g id="Слой_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer"></metadata>
         <path class="fill-black" d="M13 66c8,-12 21,-8 30,3 4,4 7,13 17,20 -13,-5 -17,-13 -22,-19 -7,-8 -17,-9 -22,0 -5,9 -7,15 -15,17 10,-9 8,-15 13,-21z"></path>
         <path class="inter-fill inter-stroke" :class="{'inter-active':selected}" d="M34 10c1,1 2,2 2,3"></path>
         <path class="inter-fill inter-stroke" :class="{'inter-active':selected}" d="M34 10c2,-4 12,-5 13,0 3,18 -4,44 -22,49 -16,-4 -16,-21 -20,-28 0,-3 -1,-8 0,-12 5,-10 7,-19 14,-19 7,0 12,6 16,9z"></path>
     </g>
    </svg>
</template>

<script>
    import {implantMixin} from '@/mixins/implant.js'

    export default {
        mixins: [implantMixin]

    }
</script>

<style scoped>

</style>
